import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { AskAiConfiguration } from '@lumapps/ask-ai-configurations/types';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/ask-ai-audience`,
    id: 'agent-hub-ask-ai-audience',
    appId: AppId.backOffice,
});

export const getAskAiAudienceEditionRoute = (configurationId: AskAiConfiguration['id']): Route =>
    getEditRoute(configurationId);

export {
    baseRoute as agentHubAskAiAudienceAdminRoute,
    editRoute as agentHubEditAskAiAudienceRoute,
    createRoute as agentHubCreateAskAiAudienceRoute,
};
